<template>
  <div class="step-qna program-questions-section">
    <div class="d-flex justify-content-center">
      <h4>Select the type of property you would like to sell</h4>
    </div>
    <b-container>
      <b-row class="mb-3 property-types" v-for="(pt, i) in propertyTypes" :key="`property-type-${i}`">
        <b-col>
          <b-button class="button" pill variant="outline-secondary"
            :pressed="propertyType === pt.cashOffer" 
            @click="updatePropertyType(pt.cashOffer)"
          >
            <b-icon v-if="pt.icon !== ''" :icon="pt.icon" aria-hidden="true"></b-icon>
            {{ pt.label }}
          </b-button>
        </b-col>
      </b-row>
    </b-container>
    <section v-if="false">
      <div class="d-flex justify-content-center">
        <h4 class="center">What program are you interested in today?</h4>
      </div>
      <div class="row button-row">
        <div class="col">   
          <b-button class="button" pill variant="outline-secondary" 
            :pressed="programType === 'CASH_OFFER_ONLY'"
            @click="onSelectedType('CASH_OFFER_ONLY')"
          >
            Cash Offer Only
          </b-button>
        </div>
      </div>
      <div class="row button-row">
        <div class="col">   
          <b-button class="button" pill variant="outline-secondary"
            :pressed="programType === 'SELL_AND_LEASEBACK'"
            @click="onSelectedType('SELL_AND_LEASEBACK')"
          >
            Sell and Leaseback
          </b-button>
        </div>
      </div>
    </section>
    <div v-if="programType === 'SELL_AND_LEASEBACK'">
      <section>
        <div class="d-flex justify-content-center">
          <h4 class="center">How long do you need a Leaseback?</h4>
        </div>
        <div class="row button-row">
          <div class="col">   
            <b-button class="button" pill variant="outline-secondary"
              :pressed="leaseBackTime === '1-3 months'"
              @click="onSelectedTime('1-3 months')"
            >
              1-3 Months
            </b-button>
          </div>
        </div>
        <div class="row button-row">
          <div class="col">   
            <b-button class="button" pill variant="outline-secondary"
              :pressed="leaseBackTime === '3-6 months'"
              @click="onSelectedTime('3-6 months')"
            >
              3-6 Months
            </b-button>
          </div>
        </div>
        <div class="row button-row">
          <div class="col">   
            <b-button class="button" pill variant="outline-secondary"
              :pressed="leaseBackTime === '6-12 months'"
              @click="onSelectedTime('6-12 months')"
            >
              6-12 Months
            </b-button>
          </div>
        </div>
        <div class="row button-row">
          <div class="col">   
            <b-button class="button" pill variant="outline-secondary" 
              :pressed="leaseBackTime === '1-3 years'" 
              @click="onSelectedTime('1-3 years')"
            >
              1-3 Years
            </b-button>
          </div>
        </div>
      </section>
    </div>
    <div class="d-flex justify-content-center">
      <h4 class="center">According to you, what is the approximate value of the property?</h4>
    </div>
    <div class="row justify-content-center">
      <div class="contain">
        <h4><strong class="blue-text-xl">{{ getValueAsCurrency }}.00<span v-if="estimatedValue === maxVal">+</span></strong></h4>
        <b-form-input type="range" v-model.number="estimatedValue" :min="minVal" :max="maxVal" :step="step"
                      @change="updateEstimatedValue(estimatedValue)" size="lg"/>
        <p class="center-80">adjust the price above by moving the blue dot left or right</p>
      </div>
    </div>
  </div>
</template>

<script>
  import {saveField} from "@/services/apiService";
  import {propertyTypes} from "@/constants";

  export default {
    name: "ProgramQuestions",
    data (){
      return {
        propertyTypes: propertyTypes,
        propertyType: null,
        programType: 'CASH_OFFER_ONLY',
        leaseBackTime: null,
        estimatedValue: 400000,
        minVal: 150000,
        maxVal: 10000000,
        step: 5000,
      }
    },
    methods: {
      formatCurrency: function (value) {
        if (typeof value !== "number") {
          return value + '-nan';
        }
        const formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 0
        });
        return formatter.format(value);
      },
      onSelectedType: function (value) {
        this.programType = value
        this.onSelectedValue('programType','interestedProgram', value)
      },
      onSelectedTime: function (value) {
        this.leaseBackTime = value
        this.onSelectedValue('leaseBackTime','leasebackTimeNeeded', value)
      },
      updateEstimatedValue: function (value) {
        this.estimatedValue = value;
        this.onSelectedValue('estimatedValue','estimated_value', value);
      },
      updatePropertyType: function (value) {
        this.propertyType = value;
        this.onSelectedValue('propertyType', 'propertyType', value);
      },
      onSelectedValue: function (field, saveAs, value) {
        this.$emit('on-value-entry', { field: field, saveAs: saveAs, value: value });
        saveField(saveAs, value);
      },
    },
    computed:{
      getValueAsCurrency() {
        return this.formatCurrency(this.estimatedValue)
      }
    }
  }
</script>

<style scoped>
.button-row{
  padding: 5px;
}
.button{
  margin: auto;
  left: 0;
  right: 0;
  padding: 10px;
  width: 175px;
}
.blue-text-xl {
  color:rgb(0, 124, 255);
  font-size:1.5em;
}

input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  position: relative;
  top: -9px;
  z-index: 1;
  width: 35px;
  height: 35px;
  border-radius: 45px;
}
</style>
